import { render, staticRenderFns } from "./mailconfiguration.vue?vue&type=template&id=eef3e932&"
import script from "./mailconfiguration.vue?vue&type=script&lang=js&"
export * from "./mailconfiguration.vue?vue&type=script&lang=js&"
import style0 from "./mailconfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports